import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Quo Vadis?',
  slug: 'quo-vadis',
  category: 'Quo Vadis?',
  date: '2025-05-16',
  image: 'https://dpnelson.com/wp-content/uploads/2025/05/quovadis.jpeg',
  excerpt: '"Quo Vadis" is a Latin phrase that asks, "where are you going?" It offers a chance to look to our values, our purpose, and our identity.',
  body: `Where Are You Going?

"Quo Vadis" is a Latin phrase that asks, "where are you going?" It offers a chance to look to our values, our purpose, and our identity to identify our goals, aspirations, and the paths we might take next in creating a fulfilling life and make a meaningful contribution.

It's the beginning. The beginning of a fulfilled life. The beginning of a lot of work. It's the beginning of the next chapter….

**Pivot**

We only ask "quo vadis?" at a crossroads in life. It's time to pivot, but how? Where? The crossroads is a place in life to reflect on our aspirations, weigh our options, and make choices that align with our long-term vision and goals.

**Reflection**

Using "quo vadis" to take the time to examine your strengths, your weaknesses, and your values. In aligning choices (thoughts & actions) with beliefs (identity & values), you'll find a purpose that sustains you through to the next.

**Resilience**

When life changes our circumstance, it is hard to adapt. Hard to embrace change. Hard to adapt to new circumstances. Especially when the new territory is unfamiliar. When you feel lost.

Quo Vadis can be a reminder to stay open-minded and flexible, ready to adjust course. It's a way to stay resilient and navigate the ever-evolving landscapes of our lives.

**Meaning**

Times like this tend to put the focus on goals and results. "Quo vadis" does draw focus on the destination, but the real beauty lies in the journey. This time of reflection is an opportunity to embrace the process of exploration, growth, and self-discovery. The results will happen as you do the work, but the work (the reflection, the planning, the moving towards goals) IS the reward.

**Helpful Questions**

"Quo vadis?" can trigger a series of questions to examine the direction in which your life is headed and encourage you to assess whether you really are aligned with your deepest values, passions, and ambitions. Here are a few questions to get started:

- What do I enjoy doing?
- What am I good at?
- What matters to me?
- What need around me can I fill?

These questions of identity, affinity, ability, and opportunity will lead the way.

So, where are you going?`,
}

export default post
